// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fbrY","newExpiryDate":"styles_newExpiryDate__1XnSl","footer":"styles_footer__2tNuU"};